__turbopack_context__.v({
  "icon1": "GlobalParallax-module__52uTgG__icon1",
  "icon2": "GlobalParallax-module__52uTgG__icon2",
  "icon3": "GlobalParallax-module__52uTgG__icon3",
  "icon4": "GlobalParallax-module__52uTgG__icon4",
  "icon5": "GlobalParallax-module__52uTgG__icon5",
  "parallaxIcon": "GlobalParallax-module__52uTgG__parallaxIcon",
  "parallaxWrapper": "GlobalParallax-module__52uTgG__parallaxWrapper",
});
